var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.icon === 'BRL')?_c('img',{class:[`w-${_vm.size}`, ..._vm.classess],attrs:{"src":_vm.pathFlagBrazil}}):_c('i',{class:[_vm.icon, `text-${_vm.size}xl` , ..._vm.classess],style:({ color: _vm.color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }